import {
  RedditIcon_default
} from "./chunk-FEV3KTGE.mjs";
export {
  RedditIcon_default as default
};
